import React from "react";
import { Form, Button, Tab } from "react-bootstrap";
// _includes
import { common, history } from "_helpers";
// pages
import TopLocation from "./Location/TopLocation";
import TopVisitors from "./Location/TopVisitors";
import LocationReport from "./Location/LocationReport";

class ReportLoc extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: history.location.pathname.split("/")[3],
    };
  }

  componentDidMount() {
    this.checkAccess();
  }

  setTab = (tab) => {
    this.setState({
      activeTab: tab,
    });
    history.push(tab);
  };

  // page access
  checkAccess() {
    const { activeTab } = this.state;
    let pageList = {
      1: "TOPLOCATIONSREPORT_PAGEACCESS",
      2: "TOPVISITORSREPORT_PAGEACCESS",
      3: "LOCATIONSREPORT_PAGEACCESS",
    };
    if (!common.isAccess(pageList[activeTab])) {
      common.accessDenied();
    } else {
      return true;
    }
  }

  render() {
    const { activeTab } = this.state;
    return (
      <div className="pageContent">
        <Tab.Container activeKey={activeTab}>
          <div className="contentHead">
            <div className="row">
              <div className="col-sm-5 poFlex">
                <h1> Locations Report </h1>
                <ul>
                  <li>
                    <a href="#">Home</a>
                  </li>
                  <li>
                    <a href="#" className="noPipe">
                      Locations report
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-sm-7">
                <Form className={`poTabs poFlex poDefault`}>
                  {common.isAccess("TOPLOCATIONSREPORT_PAGEACCESS") && (
                    <Button
                      variant="primary"
                      className={activeTab != 1 ? "inActive" : ""}
                      onClick={() => this.setTab("1")}
                    >
                      Top Locations
                    </Button>
                  )}
                  {common.isAccess("TOPVISITORSREPORT_PAGEACCESS") && (
                    <Button
                      variant="primary"
                      className={activeTab != 2 ? "inActive" : ""}
                      onClick={() => this.setTab("2")}
                    >
                      Top Visitors
                    </Button>
                  )}
                  {common.isAccess("LOCATIONSREPORT_PAGEACCESS") && (
                    <Button
                      variant="primary"
                      className={activeTab != 3 ? "inActive" : ""}
                      onClick={() => this.setTab("3")}
                    >
                      Location Report
                    </Button>
                  )}
                </Form>
              </div>
            </div>
          </div>
          <div className="contentBody">
            <div className="content">
              <Tab.Content>
                {common.isAccess("TOPLOCATIONSREPORT_PAGEACCESS") && (
                  <Tab.Pane eventKey="1" title="Top Location">
                    <TopLocation
                      ref={(instance) => {
                        this.toplocation = instance;
                      }}
                    />
                  </Tab.Pane>
                )}
                {common.isAccess("TOPVISITORSREPORT_PAGEACCESS") && (
                  <Tab.Pane eventKey="2" title="Top Visitors">
                    <TopVisitors
                      ref={(instance) => {
                        this.topvisitors = instance;
                      }}
                    />
                  </Tab.Pane>
                )}
                {common.isAccess("LOCATIONSREPORT_PAGEACCESS") && (
                  <Tab.Pane eventKey="3" title="locationReport">
                    <LocationReport
                      ref={(instance) => {
                        this.locationReport = instance;
                      }}
                    />
                  </Tab.Pane>
                )}
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    );
  }
}
export { ReportLoc };
